import script from "./BuscadorGruposMobileHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorGruposMobileHome.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorGruposMobileHome.vue?vue&type=style&index=0&id=194182fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194182fe"]])

export default __exports__